export const REPETITION_LIMIT = 4;

export function repetitionPositionKey(position) {
  const fen = typeof position === 'string' ? position : position?.fen;
  if (!fen) return null;

  const parts = fen.trim().split(/\s+/);
  if (parts.length < 3) return null;

  // En-passant is forbidden in SumoChess. Move clocks also do not affect the
  // legal position, while side-to-move and castling rights do.
  return parts.slice(0, 3).join(' ');
}

export function repetitionCount(positionHistory, currentPosition) {
  const currentKey = repetitionPositionKey(currentPosition);
  if (!currentKey) return 0;

  const keys = (positionHistory || [])
    .map(repetitionPositionKey)
    .filter(Boolean);

  // Some callers have already appended the live position; others have not.
  if (keys[keys.length - 1] !== currentKey) keys.push(currentKey);
  return keys.filter((key) => key === currentKey).length;
}

export function hasFourfoldRepetition(positionHistory, currentPosition) {
  return repetitionCount(positionHistory, currentPosition) >= REPETITION_LIMIT;
}
